// @import
import { ensureHTMLElement } from "@src/js/lib/ensure";
import { addPrevNextBtnsClickHandlers } from "@src/js/lib/slider";
import Alpine from "alpinejs";
import EmblaCarousel from "embla-carousel";

Alpine.directive("cards-campus", (element, {}, { cleanup }) => {
  const viewport = element.querySelector(".c-cards-campus__slider-viewport");
  if (!viewport) return;

  const OPTIONS = { align: "start", inViewThreshold: 0.1, loop: true, slidesToScroll: 1 } as const;

  const dom = {
    slides: element.querySelectorAll(".c-cards-campus__slider-slide"),
    viewportNode: ensureHTMLElement(element.querySelector(".c-cards-campus__slider-viewport")),
    container: ensureHTMLElement(element.querySelector(".c-cards-campus__slider-container")),
    nextBtnNode: ensureHTMLElement(element.querySelector(".c-cards-campus__btn-next")),
    prevBtnNode: ensureHTMLElement(element.querySelector(".c-cards-campus__btn-prev")),
  };

  if (dom.slides.length && dom.slides.length <= 3) {
    dom.container.appendChild(dom.slides[0].cloneNode(true));
    dom.container.appendChild(dom.slides[1].cloneNode(true));
  }

  const emblaApi = EmblaCarousel(dom.viewportNode, OPTIONS);

  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, {
    nextBtn: dom.nextBtnNode,
    prevBtn: dom.prevBtnNode,
  });

  emblaApi.on("destroy", removePrevNextBtnsClickHandlers);

  cleanup(() => {
    emblaApi.destroy();
  });
});
